import { usePackage } from 'context/package.context';
import React, { useEffect, useRef } from 'react';
import 'swiper/swiper.less';
import config from '../../../config';


const CreditCardRedirect = () => {
    const { selectedPackage,threeDSessionId, triggerClick, setTriggerClick, callBackUrl } = usePackage();
    const redirectClick = useRef(null);
    useEffect(() => {
        if (triggerClick) {
            redirectClick.current.click();
            setTriggerClick(false); // 3D form gönderildikten sonra sıfırla, tekrar gönderimi önle
        }
    }, [triggerClick]);

  return (
    <>
       <React.Fragment>
           <div style={{display:'none'}}>
            <form 
                 action={config.paycellRedirectUrl}
                method="post">
                    <input name="threeDSessionId" value={threeDSessionId} />
                    <input name="amount" value={selectedPackage?.prize} />
                    <input  name="callbackurl" value={callBackUrl} />
                    <input style={{ position: "inherit", float: "right" }}  ref={redirectClick} formMethod='post'
                        type='submit' name='submit' value='Bankaya Gönder'>
                    </input>
            </form>
            </div>
        </React.Fragment>
    </>
  );
};

export default CreditCardRedirect;
